/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_DeductedInputs */

const en_admin_users_credits_deducted = /** @type {(inputs: Admin_Users_Credits_DeductedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits deducted`)
};

/**
* | output |
* | --- |
* | "Credits deducted" |
*
* @param {Admin_Users_Credits_DeductedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_deducted = /** @type {((inputs?: Admin_Users_Credits_DeductedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_DeductedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_credits_deducted(inputs)
});
export { admin_users_credits_deducted as "admin.users.credits_deducted" }